import {
  ButtonWrapper,
  Button,
  ExplosionRing,
  ParticleBurst,
} from "./ExplosionButton.styles";

const ExplosionButton = ({
  children,
  isLoading = false,
  isExploding = false,
  disabled = false,
  subtle = false,
  onClick,
  style,
  small,
  ...props
}) => {
  return (
    <ButtonWrapper
      $isLoading={isLoading}
      $isExploding={isExploding}
      $subtle={subtle}
      onClick={onClick}
      style={style}
    >
      <ExplosionRing $isExploding={isExploding} $subtle={subtle} />
      <ParticleBurst $isExploding={isExploding} $subtle={subtle} />
      <Button
        disabled={disabled || isLoading}
        $isLoading={isLoading}
        $isExploding={isExploding}
        $subtle={subtle}
        $small={small}
        {...props}
      >
        {children}
      </Button>
    </ButtonWrapper>
  );
};

export default ExplosionButton;
